<div>
  @if (!(isSummaryStep$ | async)) {
    <app-product-stepper></app-product-stepper>
  }
  @if (showCompProduct$ | async) {
    <app-comp-product-stepper></app-comp-product-stepper>
  }
</div>
